<div class="nudge" *ngIf="!hideNudge && !util.isApp()">
  <img src="/assets/images/gift_red.png" loading="lazy" alt="gift">
  <div class="text">{{text}}<strong><a
        [href]="isIos ? vars.appLink.app_flyer : vars.appLink.app_flyer_android"
        (click)="appDownloadEvent()" target="_blank">Download Now</a></strong>
  </div>
  <div *ngIf="isMobile" class="close"><a (click)="close()"><mat-icon>close</mat-icon></a></div>
</div>